import { Lager_Asteria_Bankingconnection } from '@/__generated__/graphql';
import { TypedDocumentNode, gql } from '@apollo/client';

export type GetBankingConnectionQueryType = {
  lager_asteria_bankingconnection: Array<
    Pick<
      Lager_Asteria_Bankingconnection,
      'uid' | 'integration' | 'connection_status' | 'is_onboarded' | 'bank'
    >
  >;
};

export type GetBankingConnectionQueryVariablesType = {
  uid: string;
};

export const getBankingConnectionQuery = gql`
  query getBankingConnectionQuery($uid: String!) {
    lager_asteria_bankingconnection(where: { uid: { _eq: $uid } }) {
      uid
      integration
      connection_status
      is_onboarded
      bank
    }
  }
` as TypedDocumentNode<
  GetBankingConnectionQueryType,
  GetBankingConnectionQueryVariablesType
>;
